import React from 'react'
import {Link} from 'react-router-dom'
import {useIntl} from 'react-intl'

const NotFound = () => {
  const intl = useIntl()

  return (
    <div className='d-flex flex-column flex-center flex-column-fluid'>
      <div className='d-flex flex-column flex-center text-center p-10'>
        <div className='card card-flush w-lg-650px py-5'>
          <div className='card-body py-15 py-lg-20'>
            <div className='mb-7'>
              <h1 className='fw-bolder fs-2hx text-gray-900 mb-4'>
                {intl.formatMessage({id: 'NOTFOUND.TITLE'})}
              </h1>
              <div className='fw-semibold fs-6 text-gray-500 mb-7'>
                {intl.formatMessage({id: 'NOTFOUND.DESCRIPTION'})}
              </div>
            </div>

            <div className='mb-11'>
              <div
                className='fw-bold text-gray-300'
                style={{fontSize: '8rem', lineHeight: 1}}
              >
                404
              </div>
            </div>

            <div className='d-flex flex-center gap-3 flex-wrap'>
              <Link to='/dashboard' className='btn btn-primary'>
                {intl.formatMessage({id: 'NOTFOUND.BACK'})}
              </Link>
              <Link to='/help' className='btn btn-light-primary'>
                {intl.formatMessage({id: 'MENU.HELP'})}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export {NotFound}
